import { default as en } from './en/messages.json';

export default {
    en: { translation: en },
};
